import { render, staticRenderFns } from "./ArticlesCreate.vue?vue&type=template&id=1aba9bec&scoped=true&"
import script from "./ArticlesCreate.vue?vue&type=script&lang=js&"
export * from "./ArticlesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba9bec",
  null
  
)

export default component.exports